import { Signal } from "@lit-labs/signals";
import type { CreatorMessage } from "api-contracts/rpc/get-creator-messages";
import type { SortState } from "ui-components/wow-base-table/types";
import { sortItems } from "ui-components/wow-base-table/sort-utils";
import type { SortEntry } from "ui-components/wow-base-table/sort-types";
import type { IWritableCreatorMessagesState } from "./types";

const STATUS_ORDER: Record<string, number> = {
  sending: 0,
  scheduled: 1,
  draft: 2,
  sent: 3,
  failed: 4,
};

export class CreatorMessagesState implements IWritableCreatorMessagesState {
  readonly messages = new Signal.State<CreatorMessage[]>([]);
  readonly isLoading = new Signal.State<boolean>(false);
  readonly errorMessage = new Signal.State<string>("");
  readonly activeSorts = new Signal.State<SortEntry[]>([]);
  readonly communityCount = new Signal.State<number>(0);

  get primarySortState(): SortState {
    const first = this.activeSorts.get()[0];
    if (!first) return { column: null, direction: "none" };
    return { column: first.column, direction: first.direction };
  }

  getSortedItems(items: CreatorMessage[]): CreatorMessage[] {
    return sortItems(items, this.activeSorts.get(), STATUS_ORDER);
  }
}
